<template>
  <div v-if="mockup">
    <div class="message-loading-group" v-bind:class="{active: loadingMedia}">
        <div class="message-loading-div">
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
    <mockup :mockup="mockup" :key="mockup.id" :preview="media.src" /> 
  </div>
  <div v-else class="omcustom-product-image">
    <video width="100%" controls v-if="media.type && media.type == 'video'">
      <source :src="media.src" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <img v-else :src="media.src" style="width:100%;height:auto"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Mockup from '../Mockup/Mockup'
import { get } from 'lodash'

export default {
  components: { Mockup },
  props: {
    media: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      mockup: null
    }
  },
  mounted() {
    const { media, mockups } = this
    var fileName = media.src.replace(/^.*[\\\/]/, '')
    var mockupID = get(fileName.split('-', 3), [0])
    if (mockupID) {
      this.mockup = mockups.find(m => m.id === mockupID)
    }
  },
  watch: {
    mockups() {
      if (this.media.media_type === 'image') {
        var mockupId = get(
          this.media.src.replace(/^.*[\\\/]/, '').split('-', 3),
          '[0]'
        )
        this.mockup = this.mockups.find(m => m.id === mockupId)
      }
    },
    mockup(mockup) {
      if (mockup) {
        this.$emit('isrender', true)
      }
    }
  },
  computed: {
    ...mapGetters(['mockups', 'variantMockups', 'currentSlide', 'loadingMedia']),
    isVisible() {
      return this.currentSlide === this.index
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Media/Media.vue